// InputField.js
import React from "react";
import provinces from "./province.json"; // Assicurati di importare le province correttamente

export const InputFieldLogin = ({
  id,
  type,
  value,
  onChange,
  onFocus,
  onBlur,
  selected,
  label,
}) => (
  <div className="mt-8 relative">
    <div
      className={`block text-gray-400 text-sm font-bold mb-2
      ${selected || value ? "ml-0 -top-4" : "ml-3 top-2"}  
      text-left transition-all duration-300 absolute pointer-events-none `}
      htmlFor={id}
    >
      {label}
    </div>
    <input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      className="appearance-none border-b-2 w-full py-1 px-3 text-gray-700 outline-none focus:border-black transition"
    />
  </div>
);

export const InputFieldOptions = ({
  id,
  label,
  value,
  onKeyDown,
  onChange,
  type,
  disabled,
}) => (
  <div className="text-left relative">
    <label htmlFor={id} className="block text-gray-700">
      {label}
    </label>

    <input
      id={id}
      type={type}
      value={value || ""}
      disabled={disabled || false}
      onChange={onChange}
      onKeyDown={onKeyDown}
      className="appearance-none border rounded-sm w-full py-1 px-3 text-gray-700 outline-none focus:border-black transition"
    />
  </div>
);

export const ProvinceDropdown = ({ label, id, value, onChange }) => {
  const handleProvinceChange = (event) => {
    onChange(event);
  };

  return (
    <div className="text-left relative">
      <label htmlFor={id} className="block text-gray-700">
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={handleProvinceChange}
        className="appearance-none border rounded-sm w-full py-1 px-3 text-gray-700 outline-none focus:border-black transition"
      >
        <option value="">Seleziona una provincia</option>
        {provinces.map((province) => (
          <option key={province.code} value={province.code}>
            {province.name}
          </option>
        ))}
      </select>
    </div>
  );
};
